import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
const _sfc_main = {};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { attrs: { "xmlns": "http://www.w3.org/2000/svg", "width": "44", "height": "44", "viewBox": "0 0 44 44", "fill": "none" } }, [_c("path", { attrs: { "d": "M11.0013 32.0966H8.2513H3.66797V7.3457H40.3346V32.0966H33.0013", "stroke": "currentColor", "stroke-width": "1.7", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M22 29L14 37H30L22 29Z", "stroke": "currentColor", "stroke-width": "1.7", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("circle", { attrs: { "cx": "16.043", "cy": "19.709", "r": "1.375", "fill": "currentColor" } }), _c("circle", { attrs: { "cx": "22", "cy": "19.709", "r": "1.375", "fill": "currentColor" } }), _c("circle", { attrs: { "cx": "27.957", "cy": "19.709", "r": "1.375", "fill": "currentColor" } })]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const ScreenSharingIcon = __component__.exports;
export {
  ScreenSharingIcon as default
};
